export default __webpack_public_path__ + "static/media/notfound.b55eaac4.png";